import React from 'react';
import { type CallingCountryCode } from '@wix/form-validator';

export interface PhoneFieldContextValue {
  currentValue: string;
  selectedCountryCode: CallingCountryCode | undefined;
  handlePhoneChange: (newValue: string) => void;
  handleCountryCodeChange: (countryCode: CallingCountryCode) => void;
}

export const PhoneFieldContext =
  React.createContext<PhoneFieldContextValue | null>(null);

export const usePhoneFieldContext = (): PhoneFieldContextValue => {
  const context = React.useContext(PhoneFieldContext);

  if (!context) {
    throw new Error('Phone field components must be used within PhoneField');
  }

  return context;
};
